import { lazy } from 'react'

export const ClientPageAsync = lazy(() => import('./ClientPage'))
